import React from "react";

const Edit = (props: any) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2003 0.299927C13.3001 0.299927 13.3997 0.299933 13.3997 0.399933L16.4913 3.49994C16.591 3.59994 16.591 3.79993 16.4913 3.89993L6.7182 13.7C6.61847 13.8 6.419 13.8 6.31927 13.7L5.42172 12.7999C5.32199 12.6999 5.32199 12.4999 5.42172 12.3999C5.52144 12.2999 5.72092 12.2999 5.82064 12.3999L6.51873 13.0999L15.8929 3.69995L13.2003 0.999939L10.0091 4.19995C9.9094 4.29995 9.70992 4.29995 9.6102 4.19995C9.51047 4.09995 9.51047 3.89993 9.6102 3.79993L13.0009 0.399933C13.1006 0.299933 13.1006 0.299927 13.2003 0.299927Z"
        fill="black"
      />
      <path
        d="M13.998 3.59998C14.0978 3.59998 14.0978 3.59998 14.1975 3.69998C14.2972 3.79998 14.2972 3.99998 14.1975 4.09998L6.7181 11.6C6.61838 11.7 6.4189 11.7 6.31918 11.6C6.21945 11.5 6.21945 11.3 6.31918 11.2L13.7986 3.69998C13.7986 3.69998 13.8983 3.59998 13.998 3.59998Z"
        fill="black"
      />
      <path
        d="M12.8015 2.69998C12.9012 2.59998 12.9012 2.59998 13.001 2.59998C13.1007 2.59998 13.1007 2.59998 13.2004 2.69998C13.3002 2.79998 13.3002 2.99998 13.2004 3.09998L5.72103 10.6C5.62131 10.7 5.42183 10.7 5.32211 10.6C5.22238 10.5 5.22238 10.3 5.32211 10.2"
        fill="black"
      />
      <path
        d="M8.3136 5.19995C8.41332 5.19995 8.41333 5.19993 8.51306 5.29993C8.61278 5.39993 8.61278 5.59995 8.51306 5.69995L3.82595 10.3999L5.02267 11.5999C5.1224 11.6999 5.1224 11.8999 5.02267 11.9999C4.92295 12.0999 4.72347 12.0999 4.62375 11.9999L3.22763 10.5999C3.1279 10.4999 3.1279 10.3 3.22763 10.2L8.11413 5.29993C8.11413 5.29993 8.21387 5.19995 8.3136 5.19995Z"
        fill="black"
      />
      <path
        d="M0.335541 16.5C0.235815 16.4 0.23584 16.3 0.23584 16.2L2.42975 11.3C2.42975 11.2 2.52952 11.1 2.72897 11.1C2.92843 11.1 3.02811 11.2 3.12784 11.3L1.33279 15.6L5.52127 13.9C5.621 13.9 5.82041 13.9 5.92014 14.1C6.01986 14.2 6.01989 14.4 5.82044 14.4L0.634705 16.6C0.634705 16.6 0.435266 16.6 0.335541 16.5Z"
        fill="black"
      />
    </svg>
  );
};

export default Edit;
